import { render, staticRenderFns } from "./label-set-detail-table.vue?vue&type=template&id=44021280&"
import script from "./label-set-detail-table.vue?vue&type=script&lang=js&"
export * from "./label-set-detail-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports